( function() {
    "use strict";

    angular
        .module("ccsTrApp")
        .service("FixationCustomService", FixationCustomService);

    FixationCustomService.$inject = ['$http'];

    function FixationCustomService($http) {
        return {
            returnFixationsByShipmentId: returnFixationsByShipmentId,
            returnFixationsByContractId: returnFixationsByContractId,
            getMinifiedFixationsForInvoiceDialogByContract: getMinifiedFixationsForInvoiceDialogByContract,
            deleteFixationById: deleteFixationById
        };

        function returnFixationsByShipmentId(id) {
            var url = "api/fixations/shipment?shipment-id=" + id;
            return $http.get(url);
        }

        function returnFixationsByContractId(id) {
            var url = "api/fixations/contract?contract-id=" + id;
            return $http.get(url);
        }

        function getMinifiedFixationsForInvoiceDialogByContract(id) {
            var url = "api/fixations/minified/invoice-dialog/contract/" + id;
            return $http.get(url);
        }

        function deleteFixationById( id ) {
            var url = "api/fixations/" + id;
            return $http.delete(url);
        }
    }
})();
